import { PopoverOrigin } from '@material-ui/core';

export const anchorOrigin: PopoverOrigin = {
    vertical: 'bottom',
    horizontal: 'right',
};

export const transformOrigin: PopoverOrigin = {
    vertical: 'top',
    horizontal: 'right',
};
